import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;
export const getVoiceReportingTextAnalysisStats: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) =>
  http({
    url: `${prefix}/report/voice_reporting_text_analysis_stats`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

export const getVoiceReportingTextAnalysisTimeline: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) =>
  http({
    url: `${prefix}/report/voice_reporting_text_analysis_stats_timeline`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;

export const getVoiceReportingTextAnalysisDetails: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<any> | any = (
  payload,
  cancelTokenFunc = (c) => {},
) =>
  http({
    url: `${prefix}/report/voice_reporting_text_analysis_stats_details`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken((cancel) => {
      if (typeof cancelTokenFunc === 'function') {
        cancelTokenFunc(cancel);
      }
    }),
  }) as Promise<any>;

export const getVoiceLanguageFilter: (
  payload: any,
  cancelTokenFunc?: (cancel: any) => void,
) => Promise<overviewOriginType> | overviewOriginType = (
  payload,
  cancelTokenFunc = (c) => {},
) =>
  http({
    url: `${prefix}/report/vrta_pubgm_lang_filter`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelTokenFunc),
  }) as Promise<overviewOriginType>;
